import { catalogs } from '../meta/catalogs';
import { documents } from '../meta/documents';
// eslint-disable-next-line import/no-cycle
import {
  CatTableListerFactory,
  DocTableListerFactory,
} from '../../containers/newLister/tableComponent';
// eslint-disable-next-line import/no-cycle
import ListerFactory from '../../containers/newLister';
import { others } from '../meta/others';

const DocListerFactory = (backendURL) => ListerFactory({
  backendURL,
  viewType: 'lister',
})(DocTableListerFactory());

const DocSelectorFactory = (backendURL) => ListerFactory({
  backendURL,
  viewType: 'selector',
})(DocTableListerFactory());

const CatListerFactory = (backendURL) => ListerFactory({
  backendURL,
  viewType: 'lister',
})(CatTableListerFactory());

const CatSelectorFactory = (backendURL) => ListerFactory({
  backendURL,
  viewType: 'selector',
})(CatTableListerFactory());

const catListersSelectors = Object.keys(catalogs)
  .reduce((R, cat) => ({
    ...R,
    [cat]: {
      frontend: catalogs[cat].frontend,
      backend: catalogs[cat].backend,
      lister: CatListerFactory(catalogs[cat].backend),
      selector: CatSelectorFactory(catalogs[cat].backend),
    },
  }), {});

const docListersSelectors = Object.keys(documents)
  .reduce(
    (R, doc) => ({
      ...R,
      [doc]: {
        frontend: documents[doc].frontend,
        backend: documents[doc].backend,
        // lister: getLister(TableComponent, documents[doc].backend, CommandPanels.docCommandPanel),
        lister: DocListerFactory(documents[doc].backend),
        selector: DocSelectorFactory(documents[doc].backend),
      },
    }),
    {},
  );

const otherListersSelectors = Object.keys(others)
  .reduce((R, oth) => ({
    ...R,
    [oth]: {
      frontend: others[oth].frontend,
      backend: others[oth].backend,
      lister: CatListerFactory(others[oth].backend),
      selector: CatSelectorFactory(others[oth].backend),
    },
  }), {});

const ListerSelectors = {
  cat: catListersSelectors,
  doc: docListersSelectors,
  other: otherListersSelectors,
};

export default ListerSelectors;
